import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { UserService } from '../../../../../app/auth/service';
import { ToastrService } from 'ngx-toastr';


import { AccountSettingsService } from 'app/main/pages/account-settings/account-settings.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-new-user-sidebar',
  templateUrl: './new-user-sidebar.component.html'
})
export class NewUserSidebarComponent implements OnInit {

  @Input() currentUser;
  @Input() locations;

  @Output() newItemEvent = new EventEmitter<string>();

  public data: any;
  public loadingButton = false;
  public alertClose = true;
  public alert = "Error!";

  public myUser = JSON.parse(localStorage.getItem('currentUser'));


  // private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreSidebarService} _coreSidebarService
   */
  constructor(
    private _coreSidebarService: CoreSidebarService, 
    private _httpClient: HttpClient,
    private _userService: UserService,
    private _toastrService: ToastrService,
    private _accountSettingsService: AccountSettingsService) {
    this._unsubscribeAll = new Subject();
  }

  /**
   * Toggle the sidebar
   *
   * @param name
   */
  toggleSidebar(name): void {    
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
    this.addNewItem(this.currentUser);
    this.alertClose = true;
    this.currentUser = {
      firstName: '',
      lastName: '',
      email: '',
      role:'',
      avatar: {id:'0', url:'assets/images/profile/user-uploads/user-00.png'},
      avatarFile: null
    };
  }

  /**
   * Submit
   *
   * @param form
   */
  submit(form) {

    if (form.valid) {      
      this.loadingButton = true;
      if (!this.currentUser['avatarFile']){
        this.currentUser['avatarFile'] = null
      }   
      this.alertClose = true;
        this._userService
        .createNewUser(this.currentUser['firstName'], this.currentUser['lastName'], this.currentUser['email'], this.currentUser['role'], this.currentUser['userLocations'] )
        .then(
          data => {
            // Change successful
            // Display confimation toast!
            this._toastrService.success(
              this.currentUser.firstName +' have successfully updated your profile. 🎉',
                'Success! Your profile was updated.',
              { toastClass: 'toast ngx-toastr', closeButton: true }
            );
  
            this.loadingButton = false;
            this.toggleSidebar('new-user-sidebar'); 
  
          },
          error => {
            Swal.fire({
              title: "Error",
              text: "This Account Holder are not eligible.",
              html:
                '<div><p>'+ error +'<p/></div><div class="row">',
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            this.loadingButton = false;
          }
        );

    }else{
      setTimeout(() => {
        this.loadingButton = false;
        this.alertClose = false;

      }, 1000);            
    }


  }

  addNewItem(value: any) {
    this.newItemEvent.emit(value);
  }

  selectAll() {
    this.currentUser.userLocations = this.locations.map(x => x.id);
  }  
  unselectAll() {
    this.currentUser.userLocations = [];
  }  

  ngOnInit(): void {
    this._accountSettingsService.onSettingsChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
      this.data = response;
    });

  }
}
